import { Stack, Text } from "@mantine/core";
import TravellerDrawerRow from "./TravellerDrawerRow";
import classes from "./TravellerPolicyDrawer.module.css";

const TravellerDrawerEmergency = ({ traveller }) => {
  if (!traveller) return null;
  const hasContact = traveller.emergency_name || traveller.emergency_contact || traveller.emergency_email;

  if (!hasContact) {
    return <Text size="sm" c="dimmed">No emergency contact on file.</Text>;
  }

  return (
    <div className={classes.emergencyCard}>
      <Text fw={700} c="red.7" mb="md">🆘 Emergency Contact</Text>
      <Stack gap={0}>
        <TravellerDrawerRow label="Name" value={traveller.emergency_name} />
        <TravellerDrawerRow
          label="Phone"
          value={traveller.emergency_contact}
          highlight="orange"
        />
        <TravellerDrawerRow
          label="Email"
          value={traveller.emergency_email}
          highlight="orange"
        />
      </Stack>
    </div>
  );
};

export default TravellerDrawerEmergency;
